export const environment = {
  production: true,
  apiBaseUrl: 'https://api.getyusr.com/api/v1',
  adminApiBaseUrl: 'https://api.getyusr.com/admin/api/v1',
  appVersion: 'v0.6.7',
  name: 'production',
  /** Production: lower volume. / الإنتاج: تقليل حجم الأحداث المرسلة */
  sentry: {
    tracesSampleRate: 0.1,
    breadcrumbSampleRate: 0.2,
  },
  moyasar: {
    publishableKey: 'pk_live_wy9bkvUswpDTdyBt8ZUtpznHwhe3L2hXn6vau2Ts',
    apiUrl: 'https://api.moyasar.com/v1'
  }
};
